import { gql } from '@apollo/client'

export const TERMS_OF_SERVICE_QUERY = gql`
  query termsOfServiceQuery {
    termsOfService
  }
`
